var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3038 6.187L11.0053 1.14019C10.3231 1.04673 9.55685 1 8.71582 1C2.83791 1 0.875488 3.16826 0.875488 9.645C0.875488 16.1311 2.83791 18.29 8.71582 18.29C14.6031 18.29 16.5655 16.1311 16.5655 9.645C16.5655 8.31788 16.4814 7.16832 16.3038 6.187Z",
    stroke: "#CE1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4859 1.0791V3.56606C10.4859 5.30254 11.8932 6.7091 13.6295 6.7091H16.3872",
    stroke: "#CE1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09553 10.2256H4.9303",
    stroke: "#CE1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09553 12.585L4.9303 12.585",
    stroke: "#CE1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2385 9.55474C14.1421 9.4726 14.017 9.43201 13.8906 9.44189C13.7642 9.45176 13.647 9.5113 13.5646 9.6074L11.5063 12.0089L10.399 11.0867C10.3552 11.0491 10.3043 11.0205 10.2493 11.0027C10.1943 10.9849 10.1363 10.9782 10.0787 10.9829C10.0211 10.9876 9.96497 11.0037 9.91364 11.0303C9.86231 11.0569 9.81679 11.0933 9.77971 11.1376C9.74264 11.1819 9.71475 11.233 9.69768 11.2882C9.6806 11.3433 9.67468 11.4012 9.68025 11.4586C9.68583 11.5161 9.70278 11.5718 9.73014 11.6226C9.75749 11.6734 9.7947 11.7183 9.8396 11.7547L11.3231 12.9904C11.3688 13.0285 11.4219 13.0567 11.4791 13.0734C11.5363 13.0901 11.5963 13.0948 11.6553 13.0874C11.718 13.0825 11.7791 13.0654 11.8351 13.037C11.8912 13.0086 11.941 12.9694 11.9819 12.9218L14.291 10.2269C14.3732 10.1307 14.4139 10.0059 14.4039 9.87981C14.394 9.75375 14.3344 9.63677 14.2381 9.55453",
    fill: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.a10942fa0a4a316d4d3540adbe34f74c.svg";
export { ForwardRef as ReactComponent };